<div class="mob-header container">
    <div class="row">
        <div class="col-12 d-flex jc-space-between">
            <img src="./assets/img/logo/logo-santander-red.svg" class="logo-santander-red" alt="logo-santander-red" (click)="goHome()">
            <mob-button *ngIf="VO?.continueButton?.label" [type]="'landing-page'" (actionClick)="clickEvent.emit()"
                [text]="VO?.continueButton?.label"
                [eventLabel]="'botao:quero-abrir-conta-1'" 
                [action]="'next'"
                [styleClass]="'mob-btn mob-btn-primary mob-btn-1 mob-btn-conta d-none-sm'">
            </mob-button>
        </div>
    </div>
</div>